import { Pagination } from '@/ui'

/**
 * Liste sayfalayıcısı.
 *
 * <p>Neden ortak: listeler sunucudan sayfa sayfa geliyor ama ekranlar tek
 * bir büyük sayfa isteyip ({@code size=100..200}) başlıkta toplam sayıyı
 * gösteriyordu. Sınırı aşan kurulumda "137 proje" yazıp 100 kart çizmek,
 * eksik olanı arayan kullanıcıya hiçbir ipucu vermiyordu — liste sessizce
 * kesiliyordu.
 *
 * <p>Tek sayfa varsa hiç çizilmez: gezinecek yer yokken gezinti kontrolü
 * göstermek gürültüdür.
 */
export function Pager({
  page, totalPages, onChange,
}: {
  /** 0'dan başlar (sunucunun sayfa numarası). */
  page: number
  totalPages: number | undefined
  onChange: (page: number) => void
}) {
  if (!totalPages || totalPages <= 1) return null

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', gap: 14, marginTop: 20 }}>
      <Pagination page={page + 1} total={totalPages} onChange={(p) => onChange(p - 1)} withEdges />
      <span className="nx-nums" style={{ fontSize: 13, color: 'var(--nx-fg-muted)' }}>Sayfa {page + 1} / {totalPages}</span>
    </div>
  )
}
